define.alias("shared/components/shared/social/linkedin-modal", "settings/components/shared/social/linkedin-modal");